import { CreditSelector } from './types';

export const creditStoreSelector: CreditSelector = {
  isInitialized: (state) => state.isInitialized,
  /**
   * load relevant data
   * @param {string} userId
   */
  init: (state) => state.init,
  /**
   * reset user-specific state
   */
  reset: (state) => state.reset,
  products: (state) => state.products,
  getProducts: (state) => state.getProducts,
  activeModal: (state) => state.activeModal,
  openModal: (state) => state.openModal,
  closeModal: (state) => state.closeModal,
};
